var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 4C5.55228 4 6 4.44772 6 5V17C6 17.5523 6.44772 18 7 18H19L19.1025 18.0049C19.6067 18.0562 20 18.4823 20 19C20 19.5177 19.6067 19.9438 19.1025 19.9951L19 20H7C5.34315 20 4 18.6569 4 17V5C4 4.44772 4.44772 4 5 4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 10.5523 19.5523 11 19 11C18.4477 11 18 10.5523 18 10V8.63379L14.0293 13.7656C13.8399 14.0102 13.5476 14.1542 13.2383 14.1543C12.9674 14.1542 12.7094 14.0441 12.5225 13.8525L12.4473 13.7656L11.333 12.3262L8.79102 15.6123C8.45298 16.0489 7.8244 16.1289 7.3877 15.791C6.95117 15.453 6.87117 14.8244 7.20898 14.3877L10.542 10.0801L10.6182 9.99316C10.805 9.80199 11.0625 9.69253 11.333 9.69238C11.6423 9.69238 11.9346 9.83553 12.124 10.0801L13.2373 11.5195L16.7354 7H15C14.4477 7 14 6.55228 14 6C14 5.44772 14.4477 5 15 5H20V10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.49daa3fda585ac35211ab1745554bb51.svg";
export { ForwardRef as ReactComponent };